import React, { useMemo } from "react";

const WeightInput = ({ name, label, value, onChange, required = false }) => {
  const options = useMemo(() => {
    const items = [];

    // Placeholder option (disabled, so it can't be chosen)
    items.push(
      <option key="placeholder" value="" disabled>
        Select your weight
      </option>
    );

    // "Prefer not to say" option
    items.push(
      <option key="prefer-not-to-say" value="Prefer not to say">
        Prefer not to say
      </option>
    );

    // "Under 50 lbs" option
    items.push(
      <option key="under-fifty" value="Under 50 lbs">
        Under 50 lbs
      </option>
    );

    // 50 to 350 lbs range
    for (let weight = 50; weight <= 350; weight++) {
      items.push(
        <option key={weight} value={weight}>
          {weight}
        </option>
      );
    }

    // "Over 350 lbs" option
    items.push(
      <option key="over-three-fifty" value="Over 350 lbs">
        Over 350 lbs
      </option>
    );

    return items;
  }, []);

  const selectId = `${name}-select`;

  return (
    <div>
      <label htmlFor={selectId}>{label}</label>
      <select
        id={selectId}
        className="field"
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        aria-label="Select your weight range"
      >
        {options}
      </select>
    </div>
  );
};

export default WeightInput;
